/**
 * Public review counts shown as trust signals.
 *
 * Hardcoded on purpose: the CMS only holds a curated subset of testimonials,
 * but these numbers should match the public profiles (Google Business Profile
 * `ChIJxaSa9ikLkEcRLs6pPJ70NOw`, trustpilot.com/review/aheadhealth.com). Ratings
 * read from the Places API may not be stored under the Maps Platform terms (see
 * `lib/schema.ts`), which is why this is a manual figure. Bump the counts when
 * they move materially. Read by the /reviews KPI strip and the /about key facts,
 * so the two surfaces can't drift apart.
 */

/** Google rating, as displayed (one decimal). */
export const GOOGLE_RATING = "5.0"

/** Google review count, last checked 2026-05-27. */
export const GOOGLE_REVIEW_COUNT = 34

/** Trustpilot review count, last checked 2026-05-27. */
export const TRUSTPILOT_REVIEW_COUNT = 9
